<template>
	<div class="content">
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 text-center"
				v-if="loaded && packageList.length == 0">
				<h4>មិនមានកញ្ចប់ឥវ៉ាន់</h4>
			</div>
			<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
				<stats-card data-background-color="orange">
					<template slot="content" style="padding: 5px 10px">
						<table>
							<tr>
								<td style="width: 150px">លេខកូដប្រតិបត្តិការ</td>
								<td style="width: 40px">:</td>
								<td>{{transaction.hash_id}}</td>
							</tr>
							<tr>
								<td>ចំនួនទូទាត់</td>
								<td>:</td>
								<td><b>{{config.moneylify(transaction.total_usd)}} និង {{config.moneylify(transaction.total_khr, 'khr')}}</b></td>
							</tr>
							<tr>
								<td>ចំណាំ</td>
								<td>:</td>
								<td>{{transaction.note}}</td>
							</tr>
							<tr>
								<td>ថ្ងៃបង្កើត</td>
								<td>:</td>
								<td>{{config.datelify(transaction.created_date)}}</td>
							</tr>
						</table>
					</template>
				</stats-card>
			</div>

			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33" v-for="pkg in packageList" v-if="pkg.status == 'rtn'">
				<stats-card data-background-color="orange">
					<template slot="content" style="padding: 5px 10px">
						<p class="category">
						<table style="font-size: 13px;line-height: 16px; width: 100%;">
							<tr>
								<td>លេខកូដ</td>
								<td style="width: 20px">:</td>
								<td><b>{{pkg.tracking}}</b></td>
							</tr>
							<tr>
								<td>ទីតាំង</td>
								<td>:</td>
								<td>{{pkg.location}} ({{pkg.package_type}})</td>
							</tr>
							<tr>
								<td>តម្លៃឥវ៉ាន់</td>
								<td>:</td>
								<td>{{config.moneylify(pkg.price, pkg.price_currency)}}
									<span v-if="pkg.price == 0">(ទូទាត់ជាមួយអ្នកផ្ញើរផ្ទាល់)</span>
								</td>
							</tr>
							<tr>
								<td>ថ្លៃដឹកជញ្ជូន</td>
								<td>:</td>
								<td v-if="pkg.fee_responsible == 'snd'">
									{{config.moneylify(pkg.fee, pkg.fee_currency)}}
									({{config.getStatus(pkg.fee_responsible)}})
								</td>
								<td v-else>
									{{config.moneylify(pkg.fee, pkg.fee_currency)}}
									({{config.getStatus(pkg.fee_responsible)}})
								</td>
							</tr>
							<tr>
								<td>អ្នកទទួល</td>
								<td>:</td>
								<td>{{pkg.receiver_phone}}</td>
							</tr>
							<tr v-if="pkg.note">
								<td>ចំណាំ</td>
								<td>:</td>
								<td><b style="color:red">{{pkg.note}}</b></td>
							</tr>
							<tr>
								<td>កាលបរិច្ឆេទ</td>
								<td>:</td>
								<td>{{config.datelify(pkg.created_date)}}</td>
							</tr>
						</table>

						</p>
						<p style="text-align: right;">
							<span style="text-align: right;" class="late" v-if="pkg.status == 'wdv'">រង់ចាំអ្នកដឹកជញ្ជូន</span>
							<span style="text-align: right;" class="neutral" v-if="pkg.status == 'dvr'">កំពុងដឹកជញ្ជូន</span>
							<span style="text-align: right;" class="return" v-if="pkg.status == 'rtn'">បានត្រឡប់</span>
							<span style="text-align: right;" class="active" v-if="pkg.status == 'dlv'">បានដល់អតិថិជន</span>
						</p>
					</template>
				</stats-card>
			</div>

			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33" v-for="pkg in packageList" v-if="pkg.status == 'dlv'">
				<stats-card data-background-color="orange">
					<template slot="content" style="padding: 5px 10px">
						<p class="category">
						<table style="font-size: 13px;line-height: 16px; width: 100%;">
							<tr>
								<td>លេខកូដ</td>
								<td style="width: 20px">:</td>
								<td><b>{{pkg.tracking}}</b></td>
							</tr>
							<tr>
								<td>ទីតាំង</td>
								<td>:</td>
								<td>{{pkg.location}} ({{pkg.package_type}})</td>
							</tr>
							<tr>
								<td>តម្លៃឥវ៉ាន់</td>
								<td>:</td>
								<td>{{config.moneylify(pkg.price, pkg.price_currency)}}
									<span v-if="pkg.price == 0">(ទូទាត់ជាមួយអ្នកផ្ញើរផ្ទាល់)</span>
								</td>
							</tr>
							<tr>
								<td>ថ្លៃដឹកជញ្ជូន</td>
								<td>:</td>
								<td v-if="pkg.fee_responsible == 'snd'">
									{{config.moneylify(pkg.fee, pkg.fee_currency)}}
									({{config.getStatus(pkg.fee_responsible)}})
								</td>
								<td v-else>
									{{config.moneylify(pkg.fee, pkg.fee_currency)}}
									({{config.getStatus(pkg.fee_responsible)}})
								</td>
							</tr>
							<tr>
								<td>អ្នកទទួល</td>
								<td>:</td>
								<td>{{pkg.receiver_phone}}</td>
							</tr>
							<tr v-if="pkg.note">
								<td>ចំណាំ</td>
								<td>:</td>
								<td><b style="color:red">{{pkg.note}}</b></td>
							</tr>
							<tr>
								<td>កាលបរិច្ឆេទ</td>
								<td>:</td>
								<td>{{config.datelify(pkg.created_date)}}</td>
							</tr>
						</table>

						</p>
						<p style="text-align: right;">
							<span style="text-align: right;" class="late" v-if="pkg.status == 'wdv'">រង់ចាំអ្នកដឹកជញ្ជូន</span>
							<span style="text-align: right;" class="neutral" v-if="pkg.status == 'dvr'">កំពុងដឹកជញ្ជូន</span>
							<span style="text-align: right;" class="return" v-if="pkg.status == 'rtn'">បានត្រឡប់</span>
							<span style="text-align: right;" class="active" v-if="pkg.status == 'dlv'">បានដល់អតិថិជន</span>
						</p>
					</template>
				</stats-card>
			</div>

			<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100">
				<stats-card data-background-color="orange">
					<template slot="content" style="padding: 5px 10px">
						<table>
							<tr>
								<td style="width: 150px">តម្លៃឥវ៉ាន់សរុប</td>
								<td style="width: 40px">:</td>
								<td><b>{{config.moneylify(client.total_usd, 'usd')}} + {{config.moneylify(client.total_khr, 'khr')}}</b></td>
							</tr>
							<tr>
								<td>ថ្លៃដឹកជញ្ជូនសរុប</td>
								<td>:</td>
								<td><b>{{config.moneylify(client.total_fee_usd, 'usd')}} + {{config.moneylify(client.total_fee_khr, 'khr')}}</b></td>
							</tr>
							<tr>
								<td>ទឹកប្រាក់បានទូទាត់</td>
								<td>:</td>
								<td><b>{{config.moneylify(client.total_usd - client.total_fee_usd, 'usd')}} + {{config.moneylify(client.total_khr - client.total_fee_khr, 'khr')}}</b></td>
							</tr>
						</table>
					</template>
				</stats-card>
			</div>
		</div>
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'

	export default {
		components: {
			StatsCard
		},
		data() {
			return {
				loaded: false,
				packageList: [],
				client: {},
				driver: {},
				driver_fee: {},
				transaction: { hash_id: "", created_date: 0, note: "" }
			}
		},

		created() {
			// this.getPackage();
			this.getTransaction();
		},
		computed: {

		},
		methods: {
			view(hash_id) {
				this.$router.push("/transactions/" + hash_id);
			},
			getTransaction() {
				this.$http.get(this.config.api + "/client/transaction/get/" + this.$route.params.hash_id).then(data => {
					this.transaction = data.body.data
					this.$http.get(this.config.api + "/client/transaction/get/package/" + this.$route.params.hash_id).then(data => {
						if (data.body.data.length > 0) {
							this.packageList = data.body.data[0].packageList
							this.client = data.body.data[0]
						}
						this.loaded = true
					});
				});
			},
			// getPackage() {
			// 	this.$http.get(this.config.api + "/client/transaction/get/package/" + this.$route.params.hash_id).then(data => {
			// 		if (data.body.data.length > 0) {
			// 			this.packageList = data.body.data[0].packageList
			// 			this.client = data.body.data[0]
			// 		}
			// 		this.loaded = true
			// 	});
			// },

		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Transactions/Detail.vue